import { IProjectCheckpointArtifact } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'

export const getDefaultData = (artifacts: IProjectCheckpointArtifact[]): Record<string, string | File | undefined> => {
  return artifacts.reduce((acc, artifact) => {
    return {
      ...acc,
      [artifact.id]: '',
    }
  }, {})
}
